module.exports = __webpack_public_path__ + "img/global__logo-shield.d26234a7.png";